import WriteableReview from './WriteableReviewContainer';

export default WriteableReview;
